module.exports = __webpack_public_path__ + "img/hr-level1_mining_hands.acff3ca7.png";